import React from 'react';


import EmailIcon from '@mui/icons-material/Email';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import { iconColors } from '../helpers/scripts'

const PostIconStatus = ( {code, props} ) => {


    const checkStatus = () => {

        // gray: 0 ; yellow: 1; green: 2

        let icon

        if (code === 1) {
            icon = <EmailIcon sx={{ color: iconColors.yellow }} {...props} />
        } else if (code === 2) {
            icon = <EmailIcon sx={{ color: iconColors.green }} {...props} />
        } else {
            icon = <MailOutlineIcon sx={{ color: iconColors.gray }} {...props} />
        }

        return icon
    }


    return checkStatus()
}

export default PostIconStatus;
